/**
 * lightbox - media lightbox over GLightbox (images, video, iframes),
 * entry point.
 *
 * Usage:
 *   <a href="photo.jpg" lightbox>…</a>                 // standalone item
 *   <a href="1.jpg" lightbox="tour">…</a>              // same value = one
 *   <a href="2.jpg" lightbox="tour">…</a>              // gallery (prev/next)
 *   <a href="https://youtu.be/…" lightbox>Video</a>    // type auto-detected
 *   lightbox-title / lightbox-description  → caption
 *   lightbox-type / lightbox-width / lightbox-height / lightbox-alt
 *   g.lightbox.refresh();                  // after injecting marked elements
 *   g.lightbox.open([{ href, title }], 0); // slideshow from plain data
 *   g.lightbox.gallery(files, { group });  // files jsonb → plate-grid markup
 *   g.lightbox({ loop: true });            // re-init with GLightbox options
 *
 * Marked elements auto-init on load and re-scan on lister:loaded; captions,
 * effects and the video player follow the theme + reduced-motion. Plyr is
 * served from the published vendors, injected only when a video opens.
 *
 * Requires the GLightbox vendor, which loads PER PAGE: add
 * `'vendors' => ['glightbox'], 'libs' => ['lightbox']` to the page's
 * route.php. Full reference: docs/libs/lightbox.md.
 */
import { autoInit, build, destroy, instance, open, prep, refresh } from './lightbox.js';
import { gallery } from './gallery.js';

// Bump on every meaningful change to the library.
const VERSION = '0.2.0';

// Callable (re-init with extra GLightbox options) + the method surface.
function lightbox(options) {
	return build(options || {});
}

lightbox.version = () => VERSION;
lightbox.refresh = refresh;
lightbox.open = open;
lightbox.gallery = gallery;
lightbox.instance = instance;
lightbox.destroy = destroy;
lightbox.prep = prep;

if (window.g) {
	window.g.lightbox = lightbox;
	window.g.registerLib('lightbox');
} else {
	window.lightbox = lightbox;
}

autoInit();
